var exports = {
  "nf": "xdde3148b--302b4f--link",
  "AS": "xdde3148b--302b4f--item",
  "pq": "xdde3148b--302b4f--info",
  "iq": "xdde3148b--302b4f--image-container",
};

module.exports = exports;
